import { Box, Container, Flex, Grid, GridItem, Heading, Image, Skeleton, Text, useColorModeValue } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import pages from '../assets/data/pages.json';
import getStaticAsset from '../helper/utils/utilsStaticAsset';
import { doHandleState } from '../redux/onlineSales/onlineSales.actions';
import usePages from './onlineSales/hooks/usePages';

export default function IndexPage() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const bgColor = useColorModeValue('gray.50', 'gray.900');
    const { handleGetBrand, isLoading } = usePages();

    const handleSelectBrand = (brand) => {
        dispatch(doHandleState('loadingBrand', true));

        handleGetBrand(brand.id, () => {
            dispatch(doHandleState('loadingBrand', true));
            dispatch(doHandleState('cart', []));

            navigate(`/${brand.slug}`, {
                state: {
                    brandId: brand.id,
                },
            });
        });
    };

    return (
        <Box minH='100vh' bg={bgColor} py={16}>
            <Container maxW='container.lg'>
                <Flex direction='column' align='center' mb={16}>
                    <Image src={getStaticAsset('dream_us_logo.webp')} alt='Dreamus Logo' maxW='220px' mb={8} />
                    <Heading as='h1' size='2xl' textAlign='center' mb={4} fontWeight='extrabold'>
                        Hey! Welcome to Dreamus
                    </Heading>
                    <Text fontSize='xl' color='gray.600' textAlign='center' maxW='600px'>
                        Discover a world of joy and adventure. Select one of our brands below to start playing!
                    </Text>
                </Flex>

                <Grid templateColumns={{ base: '1fr', md: 'repeat(3, 1fr)' }} gap={10}>
                    {pages.map((brand) => {
                        const primaryColor = brand.theme.colors.primary['500'];
                        return (
                            <Skeleton isLoaded={!isLoading} rounded='xl'>
                                <GridItem key={brand.id}>
                                    <Box
                                        bg='white'
                                        p={10}
                                        rounded='3xl'
                                        shadow='xl'
                                        transition='all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275)'
                                        _hover={{
                                            transform: 'translateY(-12px)',
                                            shadow: '2xl',
                                            borderColor: primaryColor,
                                            borderWidth: '3px',
                                        }}
                                        borderWidth='3px'
                                        borderColor='transparent'
                                        cursor='pointer'
                                        onClick={() => handleSelectBrand(brand)}
                                        h='full'
                                        display='flex'
                                        flexDirection='column'
                                        alignItems='center'
                                        justifyContent='center'
                                        textAlign='center'
                                        position='relative'
                                        overflow='hidden'>
                                        <Box position='absolute' top='-20%' right='-10%' w='150px' h='150px' bg={brand.theme.colors.primary['100']} rounded='full' opacity='0.3' zIndex={0} />
                                        <Image src={getStaticAsset(brand.logo)} alt={`${brand.title} Logo`} maxH='100px' mb={8} objectFit='contain' zIndex={1} />
                                        <Heading size='lg' mb={3} zIndex={1}>
                                            {brand.title}
                                        </Heading>
                                        <Text fontSize='md' color='gray.500' zIndex={1}>
                                            {brand.home.subheadline}
                                        </Text>
                                    </Box>
                                </GridItem>
                            </Skeleton>
                        );
                    })}
                </Grid>

                <Flex justify='center' mt={20}>
                    <Text fontSize='sm' color='gray.400'>
                        &copy; {new Date().getFullYear()} PT Dreamus Edutainment Indonesia. All rights reserved.
                    </Text>
                </Flex>
            </Container>
        </Box>
    );
}
